// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"599576b0","488":"19077f82","732":"0674e175","977":"03bf75f8"}[chunkId] + ".chunk.js";
};